

import wxConfig from '@/assets/js/wx_config'
import XImg from 'vux/src/components/x-img/index.vue'

export default {
name: "dynamicShare",
components: {
XImg
},
data(){
return{
query:this.$route.query,
isWxFlag:false,
userAvatar:'',
subName:'',
subFlag:false,
userName:'',
releaseTime:'',
className:''
}
},
mounted() {
this.$store.commit('UPDATE_HEAD',false);
this.$store.commit('UPDATE_FOOTER',false);
this.$store.commit('UPDATE_PAGE_TITLE','动态分享');
document.title = '动态分享'
this.isWxFlag = wxConfig.isWeiXin();
this.getDynamic()
},
methods:{
getDynamic(){
let self=this;
this.baseAjax({
url:'/h5/dynamic/get',
showLoading:true,
type:'post',
data:{
circleId:self.query.circleId,
dynamicId:self.query.dynamicId,
userId:self.query.userId
},
success:function(data){
console.log(data)
if(self.isWxFlag){
wxConfig.wxConfigBuild(self.query.userId,'111','11','11','11')
}
}
})
},

}
}



// WEBPACK FOOTER //
// ./src/components/share/dynamicShare.vue